import { SearchField } from '@sparemin/blockhead';
import { SEARCH_BAR_PLACEHOLDER } from './constants';
import * as S from './styles';

export interface SearchTriggerButtonProps {
  onOpen: () => void;
}

const SearchTriggerButton: React.FC<SearchTriggerButtonProps> = ({
  onOpen,
}) => {
  return (
    <S.SearchTriggerButton onPress={onOpen}>
      <SearchField.SearchIcon />

      <S.SearchTriggerLabel>{SEARCH_BAR_PLACEHOLDER}</S.SearchTriggerLabel>
    </S.SearchTriggerButton>
  );
};

export default SearchTriggerButton;
